export enum SnackbarType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
}

export interface SnackbarData {
  message: string,
  type: SnackbarType
}